const CancelBookingModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Cancel trip?",
  description = "Are you sure you want to cancel this booking? If your movers are already on the way, a cancellation fee may apply.",
  confirmText = "Cancel booking",
  secondaryText = "Keep booking",
  showSecondaryButton = true,
}) => {
  const visible = typeof isOpen === "boolean" ? isOpen : !!isOpen;
  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#7876A1]/50 font-instrument">
      {/* Modal container */}
      <div
        role="dialog"
        aria-modal="true"
        aria-label="Cancel trip confirmation"
        className="relative flex flex-col items-center px-[20px] pb-[20px]"
        style={{
          width: 328,
          background: "#F6F6F6",
          borderRadius: "16px",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        }}
      >
        {/* Close button — top left */}
        <div className="flex justify-start items-start w-full pt-[16px] pb-[4px] cursor-pointer">
          <img
            src="/Vision Agent Icons/X Icon/XLightpurple.svg"
            alt="close"
            onClick={onClose}
          />
        </div>

        {/* Warning icon — circle bg + triangle icon */}
        <div className="w-[72px] h-[72px] rounded-full bg-[#C8C6DF] flex items-center justify-center mt-[12px]">
          <div className="relative w-[46px] h-[46px] flex items-center justify-center">
            <img
              src="/images/NewUiIcons/Polygon4.svg"
              alt=""
              className="absolute inset-0 w-full h-full"
            />
            <img
              src="/images/NewUiIcons/AttentionIcon.png"
              alt="warning"
              className="relative z-10 w-[22px] h-[22px] mt-1"
            />
          </div>
        </div>

        {/* Title */}
        <h2 className="text-[24px] font-semibold text-[#34318C] leading-tight mt-[18px] text-center">{title}</h2>

        {/* Description */}
        <div className="mt-[14px] text-[14px] text-[#34318C] font-normal leading-[140%] text-center max-w-[260px]">{description}</div>

        {/* Buttons */}
        <div className={`flex w-full mt-[24px] ${showSecondaryButton ? "gap-[10px]" : ""}`}>
          <button
            onClick={onConfirm}
            className={`${showSecondaryButton ? "flex-1" : "w-full"} h-[48px] rounded-[15px] font-semibold text-[14px] bg-[#C8C6DF] text-[#34318C] hover:bg-[#d0cce8] focus:outline-none transition-colors`}
            aria-label="Cancel booking"
          >
            {confirmText}
          </button>
          {showSecondaryButton && (
            <button
              onClick={onClose}
              className="flex-1 h-[48px] rounded-[15px] font-semibold text-[14px] bg-[#34318C] text-white hover:bg-[#2a276b] focus:outline-none transition-colors"
              aria-label="Keep booking"
            >
              {secondaryText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CancelBookingModal;
